import {ProductPriceRangeData} from './product-price-range-data';
import {Currency} from '../enums/currency';
import {MeasureUnit} from '../../canvas/enums/measure-unit.enum';
import {PriceType} from "../enums/price-type.enum";

export class ProductPriceData {
  unit: string = MeasureUnit.UNIT_SQ_FEET; // sqft, sqm, etc
  currency: string = Currency.USD; // Currency abbreviations (lower-case): usd, eur, etc
  prices: ProductPriceRangeData[] = [new ProductPriceRangeData()];
  price = 0;
  type = PriceType.RANGE; // fixed, range
}
